export default __webpack_public_path__ + "static/media/Flag of Republic of Serbia.bd95679a.gif";